module.exports = __webpack_public_path__ + "static/img/text4.572530f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/text4.png
// module id = fl2X
// module chunks = 0